import styled from "styled-components/macro";

export const HeaderContainer = styled.div`
    width: 330px;
    padding: 38px 35px 8px 30px;
    ${({ theme }) =>
        theme.bp.xxxl`
        width: 540px;
    `}
`;
